import { useState, useEffect, useContext, useCallback } from 'react';
import { Box, Typography, TextField, Checkbox, Button, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddressInput from '../../../../components/AddressInput/AddressInput';
import { OrdersContext } from '../../../../lib/contexts/OrdersContext';

const EditAddressPopUp = ({ onClose, addAddress = false, deliveryID, thisOrder, addressToEdit }) => {
  // const [isChecked, setIsChecked] = useState(false);
  const {
    actions: { updateNewAddress, updateOrderAddress },
  } = useContext(OrdersContext);
  const [completeInfo, setCompleteInfo] = useState(false);
  const [newAddress, setNewAddress] = useState('');
  const [unitNumber, setUnitNumber] = useState('');
  const [deliveryInstructions, setDeliveryInstructions] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [defaultAddress, setDefaultAddress] = useState(false);
  const [needUnitNumber, setNeedUnitNumber] = useState(false);
  const [finalAddress, setFinalAddress] = useState('');

  const isMobileView = useMediaQuery('(max-width: 768px)');

  // useEffect(() => {
  //     console.log('here is the unitNumber in the edit address pop up: ', unitNumber);
  //     console.log('here is the deliveryInstructions in the edit address pop up: ', deliveryInstructions);
  //     console.log('here is the defaultAddress in the edit address pop up: ', defaultAddress);
  // }, [unitNumber, deliveryInstructions, defaultAddress]);

  const stateAbbreviations = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
  };

  const getStateName = (abbreviation) => {
    return stateAbbreviations[abbreviation] || abbreviation;
  };

  const handleSaveAddress = async () => {
    const tempAddress = {
      address: {
        raw_text: newAddress.sanitizedAddress,
        line_1: newAddress.street_line,
        line_2: unitNumber,
        unit_number: unitNumber,
        city: newAddress.city,
        state: newAddress.state,
        zip: newAddress.zipcode,
        preferred_delivery_time: null,
        meta: {},
        address: newAddress.sanitizedAddress,
        instructions: deliveryInstructions,
        is_primary: defaultAddress,
      },
    };

    if (newAddress?.sanitizedAddress) {
      // console.log('here is the tempAddress passed into updateNewAddress: ', tempAddress);
      const response = await updateNewAddress(tempAddress);

      if (response?.data?.result?.location?.id && thisOrder?.location?.id !== response.data.result.location.id) {
        if (thisOrder) {
          // console.log('firing updateOrderAddress with deliveryID and newAddressId');
          updateOrderAddress(deliveryID, response.data.result.location.id);
        }
        // else {
        //   console.log('firing updateOrderAddress with newAddressId');
        //   updateOrderAddress(response.data.result.location.id);
        // }

        // console.log('1234567890');
      }
      // console.log('here is the response in the edit address pop up: ', response);
      setFinalAddress(response);
    }
    onClose();
  };

  const handleButtonClick = () => {
    // Ensure all state updates are completed before calling handleSaveAddress
    setCompleteInfo(true);
    handleSaveAddress();
  };

  useEffect(() => {
    // console.log('here is the finalAddress in the edit address pop up: ', finalAddress);
    // console.log('here is the finalAddress.data.result.locatoin.id in the edit address pop up: ', finalAddress?.data?.result?.location?.id);
  }, [finalAddress]);

  // useEffect(() => {
  //     console.log('here is the needUnitNumber: ', needUnitNumber);
  //     console.log('here is the newAddress: ', newAddress);
  // }, [needUnitNumber, newAddress]);

  useEffect(() => {
    if (needUnitNumber) {
      if (newAddress && unitNumber) {
        setCompleteInfo(true);
      }
    } else {
      if (newAddress) {
        setCompleteInfo(true);
      }
    }
  }, [needUnitNumber, newAddress, unitNumber]);

  // useEffect(() => {
  //     console.log('here is the completeInfo: ', completeInfo);
  // }, [completeInfo]);

  const handleCheckboxChange = () => {
    setDefaultAddress(!defaultAddress);
  };

  useEffect(() => {
    if (addressToEdit) {
      setNewAddress({
        sanitizedAddress: addressToEdit.address,
        street_line: addressToEdit.address,
        city: addressToEdit.city,
        state: addressToEdit.state,
        zipcode: addressToEdit.zip,
      });
      setUnitNumber(addressToEdit.address_2 || '');
      setDeliveryInstructions(addressToEdit.instructions || '');
      setDefaultAddress(addressToEdit.is_primary || false);
    }
  }, [addressToEdit]);

  return (
    <Box
      id="edit-address-pop-up-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        flexShrink: 0,
        borderLeft: '1px solid var(--color4, #EBE8F3)',
        background: 'var(--color1, #FDFDFD)',
        boxShadow:
          '0px 4px 5px 0px rgba(0, 0, 0, 0.02), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
        width: isMobileView ? '400px' : '440px',
        padding: '24px 32px',
        height: 'auto',
        minHeight: '100%',
      }}
    >
      <Box
        id="edit-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          gap: '16px',
          alignSelf: 'stretch',
          flex: '1 0 auto',
        }}
      >
        <Box
          id="header-container"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 'var(--2-5, 10px)',
          }}
        >
          <Box
            id="header-sub-container"
            sx={{
              display: 'flex',
              width: '100%',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <Box
              id="back-button-container"
              sx={{
                display: 'flex',
                width: '24px',
                height: '38px',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
              }}
            >
              <ArrowBackIcon
                onClick={onClose}
                sx={{
                  height: 24,
                  flex: 1,
                  cursor: 'pointer',
                }}
              />
            </Box>
            <Box
              id="header-title-container"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '4px',
                flexShrink: 0,
                flexGrow: 1,
              }}
            >
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'center',
                  fontFamily: 'Montserrat',
                  fontSize: '24px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: '125%', // 30px
                }}
              >
                {addAddress ? 'Add Address' : 'Edit Address'}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          id="body-container"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '12px',
            alignSelf: 'stretch',
            // flex: '1 0 auto',
          }}
        >
          <Box
            id="input-with-label"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'stretch',
              gap: '8px',
              alignSelf: 'stretch',
              flex: '1 0 auto',
            }}
          >
            {/* <Box
                            id="label"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                alignSelf: 'stretch',
                            }}
                        >
                            <Typography
                                sx={{
                                    color: 'var(--color12, #1C124D)',
                                    textAlign: 'right',
                                    leadingTrim: 'both',
                                    textEdge: 'cap',
                                    fontFamily: 'Montserrat',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    lineHeight: 'normal',
                                }}
                            >
                                Recipient Name
                            </Typography>
                        </Box>
                        <TextField
                            placeholder="Recipient Name"
                            value={recipientName}
                            onChange={(e) => setRecipientName(e.target.value)}
                            InputProps={{
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    flex: '1 0 0',
                                    alignSelf: 'stretch',
                                    color: 'var(--color11, #58489A)',
                                    leadingTrim: 'both',
                                    textEdge: 'cap',
                                    fontFamily: 'Montserrat',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    height: 'var(--4, 44px)',
                                    padding: 'var(--3-5, 16px)',
                                    alignItems: 'center',
                                    alignSelf: 'stretch',
                                    borderRadius: 'var(--4, 9px)',
                                    border: '1px solid var(--color8, #A69ECA)',
                                    background: 'var(--color1, #FDFDFD)',
                                    width: isMobileView ? '340px' : '380px',
                                },
                            }}
                        /> */}
            <Box
              id="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'right',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                }}
              >
                Delivery Address
              </Typography>
            </Box>
            <AddressInput
              setNewAddress={setNewAddress}
              setNeedUnitNumber={setNeedUnitNumber}
            />
            <Box
              id="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'right',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                }}
              >
                Unit Number
              </Typography>
            </Box>
            <TextField
              placeholder="Enter"
              value={unitNumber}
              onChange={(e) => setUnitNumber(e.target.value)}
              InputProps={{
                sx: {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  flex: '1 0 0',
                  alignSelf: 'stretch',
                  color: 'var(--color11, #58489A)',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: 'normal',
                  height: 'var(--4, 44px)',
                  padding: 'var(--3-5, 16px)',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  borderRadius: 'var(--4, 9px)',
                  border: '1px solid var(--color8, #A69ECA)',
                  background: 'var(--color1, #FDFDFD)',
                  width: isMobileView ? '340px' : '380px',
                },
                inputProps: {
                  style: { textAlign: 'center' },
                },
              }}
            />
            <Box
              id="label"
              sx={{
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'stretch',
              }}
            >
              <Typography
                sx={{
                  color: 'var(--color12, #1C124D)',
                  textAlign: 'right',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                }}
              >
                Delivery Instructions
              </Typography>
            </Box>
            <TextField
              placeholder="Enter"
              value={deliveryInstructions}
              onChange={(e) => setDeliveryInstructions(e.target.value)}
              InputProps={{
                sx: {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  flex: '1 0 0',
                  alignSelf: 'stretch',
                  color: 'var(--color11, #58489A)',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: 'normal',
                  height: 'var(--4, 44px)',
                  padding: 'var(--3-5, 16px)',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  borderRadius: 'var(--4, 9px)',
                  border: '1px solid var(--color8, #A69ECA)',
                  background: 'var(--color1, #FDFDFD)',
                  width: isMobileView ? '340px' : '380px',
                },
                inputProps: {
                  style: { textAlign: 'center' },
                },
              }}
            />
          </Box>
          <Box
            id="check-box-container"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              marginTop: '16px',
            }}
          >
            <Box
              id="check-box-wrapper"
              sx={{
                display: 'flex',
                width: '20px',
                height: '20px',
                alignItems: 'flex-start',
                gap: '10px',
              }}
            >
              <Checkbox
                checked={defaultAddress}
                onChange={handleCheckboxChange}
                sx={{
                  width: '20px',
                  height: '20px',
                  flexShrink: 0,
                  borderRadius: '5px',
                  border: '1px solid var(--color11, #58489A)',
                  background: 'var(--color1, #FDFDFD)',
                }}
              />
            </Box>
            <Typography
              sx={{
                color: 'var(--color12, #1C124D)',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: 'normal',
              }}
            >
              Default Address
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        id="save-button-container"
        sx={{
          display: 'flex',
          width: isMobileView ? '400px' : '440px',
          padding: '8px 32px 40px 32px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          background: 'var(--color1, #FDFDFD)',
        }}
      >
        <Button
          onClick={handleButtonClick}
          disabled={!completeInfo}
          sx={{
            display: 'flex',
            height: 'var(--4, 44px)',
            padding: 'var(--0, 0px) var(--4, 18px)',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 'var(--4, 18px)',
            alignSelf: 'stretch',
            borderRadius: 'var(--4, 9px)',
            border: '1px solid var(--color12, #1C124D)',
            background: completeInfo ? 'var(--color12, #1C124D)' : 'grey',
          }}
        >
          <Typography
            sx={{
              color: 'var(--color1, #FDFDFD)',
              textAlign: 'center',
              leadingTrim: 'both',
              textEdge: 'cap',
              fontFamily: 'Montserrat',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}
          >
            Save Address
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default EditAddressPopUp;
